/**
 * Page Tracking Hook
 *
 * Tracks page views on route changes in the SPA.
 * Uses both GA4 (if consent given) and custom backend analytics.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackPageView } from '@/lib/telemetry';
import { backendAdapter } from '@/lib/telemetry/backendAdapter';

/**
 * Hook to track page views on route changes
 * Call this once in a component that wraps all routes
 */
export function usePageTracking(): void {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname + location.search;
        const title = document.title;

        // Track with GA4 (if consent given)
        trackPageView(path, title);

        // Track with custom backend (no consent required)
        backendAdapter.track('page_view', 'page', {
            path,
            title,
            hash: location.hash,
        });
    }, [location.pathname, location.search, location.hash]);
}
